import { render, staticRenderFns } from "./ResourceListFilters.vue?vue&type=template&id=c84cadc4&scoped=true"
import script from "./ResourceListFilters.vue?vue&type=script&lang=js"
export * from "./ResourceListFilters.vue?vue&type=script&lang=js"
import style0 from "./ResourceListFilters.vue?vue&type=style&index=0&id=c84cadc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84cadc4",
  null
  
)

export default component.exports